import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import {
  DataExporterRoute,
  DataExporterPathName,
} from '@/modules/ta/dataexporter/dataexporter.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${DataExporterRoute.DATAEXPORTERS}`,
      name: DataExporterPathName.DATAEXPORTERS,
      component: () =>
        import(/* webpackChunkName: "dataexporter-page" */ './pages/DataExporterPage.vue'),
    },
    {
      path: `/${DataExporterRoute.DATAEXPORTERS}/new`,
      name: DataExporterPathName.DATAEXPORTERS_NEW,
      component: () =>
        import(/* webpackChunkName: "dataexporter-form-page" */ './pages/DataExporterFormPage.vue'),
      props: true,
    },
    {
      path: `/${DataExporterRoute.DATAEXPORTERS}/:id`,
      name: DataExporterPathName.DATAEXPORTERFORM,
      component: () =>
        import(/* webpackChunkName: "dataexporter-form-page" */ './pages/DataExporterFormPage.vue'),
      props: true,
    },
  ],
  Module.DATAEXPORTER
);
